var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\"><div flex=\"flex\"><div layout=\"column\" class=\"itemCardHeader\"><h4>Staff Member Charge</h4></div><div style=\"margin: 5px\" class=\"form-group\"><label>Pricing List Here.</label></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/staffMembers/tabs/tab-pricing.jade
// module id = 295
// module chunks = 0